import { render, staticRenderFns } from "./veStuMoralCountShow.vue?vue&type=template&id=492e5a34&scoped=true"
import script from "./veStuMoralCountShow.vue?vue&type=script&lang=js"
export * from "./veStuMoralCountShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492e5a34",
  null
  
)

export default component.exports